/**
 * URL-hash keys for the notifications drawer, bound via `useHashDialog`
 * (see `@/hooks/use-hash-dialog`). App-shell overlays use a simple global key
 * since they are route-agnostic.
 */
export const NOTIFICATIONS_HASH = {
  /** `#notifications` — NotificationDrawer (`<Sheet>`). */
  drawer: 'notifications'
} as const;

export type NotificationsHashKey =
  (typeof NOTIFICATIONS_HASH)[keyof typeof NOTIFICATIONS_HASH];
